import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import OutsideClickHandler from 'react-outside-click-handler';
import config from '@/config';
import api from '@/shared/api';
import EditableToggle from './EditableToggle';
import MultiSelect from '../input/multiselect/MultiSelect';

const EditableEmployeeTagSelector = ({ value, onChange, readOnly, placeholder }) => {
  const [availableTags, setAvailableTags] = useState([]);

  useEffect(() => {
    api.base.get(`${config.appUrls.api}/api/employee/tags`).then(({ data }) => {
      setAvailableTags(data || []);
    });
  }, []);

  const selectedNames = value || [];
  const displayValue = selectedNames.length ? (
    <span className="bold">{selectedNames.join(', ')}</span>
  ) : null;

  return (
    <EditableToggle
      onSubmit={onChange}
      value={selectedNames}
      readOnly={readOnly}
      displayValue={displayValue}
    >
      {({ inputValue, setInputValue, submit }) => {
        const selected = inputValue || [];
        const addTag = name => {
          const clean = (name || '').trim();
          if (!clean || selected.some(t => t.toLowerCase() === clean.toLowerCase())) return;
          setInputValue([...selected, clean]);
        };
        return (
          <OutsideClickHandler onOutsideClick={submit}>
            <MultiSelect
              items={availableTags
                .filter(t => !selected.some(s => s.toLowerCase() === t.name.toLowerCase()))
                .map(t => ({ id: t.id, name: t.name, label: t.name }))}
              selectedItem={selected.map(name => ({ id: name, name, label: name }))}
              onCreateItem={name => addTag(name)}
              onItemSelected={item => addTag(item?.name)}
              onItemRemoved={item => setInputValue(selected.filter(t => t !== item.value.name))}
              placeholder={placeholder}
            />
          </OutsideClickHandler>
        );
      }}
    </EditableToggle>
  );
};

EditableEmployeeTagSelector.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  placeholder: PropTypes.string,
};

EditableEmployeeTagSelector.defaultProps = {
  value: [],
  readOnly: false,
  placeholder: '',
};

export default EditableEmployeeTagSelector;
